module.exports = __webpack_public_path__ + "img/partners-1.faf138d.svg";